/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _stroke="currentColor" stroke-width="2.5"><path pid="0" d="M2 2l12 12M2 14L14 2"/></g>'
  }
})
